import script from "./software-manage.vue?vue&type=script&lang=ts&setup=true"
export * from "./software-manage.vue?vue&type=script&lang=ts&setup=true"

import "./software-manage.vue?vue&type=style&index=0&id=06ebff82&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ebff82"]])

export default __exports__